{
  "list": {
    "title": "Hoá đơn",
    "create": "Tạo hoá đơn",
    "createExtra": "Bán thêm",
    "searchPlaceholder": "Tìm theo mã hoá đơn, tên người trả hoặc tên học viên, không cần gõ dấu",
    "client": "Khách hàng",
    "dueDate": "Hạn thanh toán",
    "amount": "Số tiền",
    "status": "Trạng thái",
    "kind": "Loại",
    "kindClose": "Chốt sổ",
    "kindManual": "Tự tạo",
    "kindTerm": "Khóa học",
    "loading": "Đang tải hoá đơn...",
    "loadError": "Không tải được danh sách hoá đơn. Thử lại sau.",
    "emptyTeachTitle": "Chưa có hoá đơn nào",
    "emptyTeachBody": "Hoá đơn sinh ra khi bạn chốt sổ tháng; điểm danh xong là chốt được.",
    "emptyFilterTitle": "Không có hoá đơn nào khớp bộ lọc",
    "searchHint": "Tìm theo mã hoá đơn, tên người trả hoặc tên học viên, không cần gõ dấu.",
    "unknownClient": "Khách hàng chưa xác định",
    "filterAll": "Tất cả",
    "subtitleTotal": "{{count}} hoá đơn",
    "subtitlePending": "{{count}} chờ thanh toán",
    "subtitleOverdue": "{{count}} quá hạn",
    "subtitleEmpty": "Chưa có hoá đơn",
    "filterGroupLabel": "Lọc theo trạng thái",
    "overdueSuffix": "trễ {{count}} ngày",
    "selectRow": "Chọn hoá đơn {{code}}",
    "sortNewest": "Mới nhất",
    "sortOldest": "Cũ nhất",
    "sortAmountDesc": "Số tiền: Cao đến thấp",
    "sortAmountAsc": "Số tiền: Thấp đến cao",
    "window": {
      "monthPickerLabel": "Chọn tháng khác",
      "reset": "Về tháng này"
    },
    "searchResults": "{{count}} kết quả cho “{{q}}”, không cần gõ dấu"
  },
  "detail": {
    "loading": "Đang tải chi tiết hoá đơn...",
    "notFound": "Không tìm thấy hoá đơn",
    "backToList": "Quay lại danh sách",
    "invoiceTitle": "Hoá đơn {{code}}",
    "publicLink": "Link công khai",
    "publicLinkHiddenImpersonating": "Ẩn khi xem như: mở link này sẽ đánh dấu hoá đơn là khách đã xem, không thể hoàn tác.",
    "edit": "Sửa",
    "delete": "Xoá",
    "deleteConfirm": "Bạn có chắc muốn xoá hoá đơn này? Hành động này không thể hoàn tác.",
    "client": "Khách hàng",
    "details": "Chi tiết",
    "created": "Ngày tạo",
    "dueDate": "Hạn thanh toán",
    "sepayTxn": "Mã giao dịch SePay",
    "lineItems": "Hạng mục",
    "description": "Mô tả",
    "qty": "SL",
    "unitPrice": "Đơn giá",
    "total": "Tổng",
    "subtotal": "Tạm tính",
    "tax": "Thuế ({{rate}}%)",
    "depositPaid": "Đã đặt cọc",
    "balanceDue": "Còn lại",
    "grandTotal": "Tổng cộng",
    "notes": "Ghi chú / Điều khoản",
    "sendInvoice": "Gửi hoá đơn",
    "sendReminder": "Gửi nhắc",
    "publicViewedAt": "Khách đã xem",
    "paidAt": "Đã thanh toán",
    "lastPaymentAt": "Thanh toán gần nhất",
    "autoMatchedShort": "Tự khớp chuyển khoản",
    "manualMarked": "Đánh dấu tay",
    "paySource": {
      "CASH": "Tiền mặt",
      "MANUAL_BANK": "Chuyển khoản ngoài",
      "ECOMMERCE": "Sàn TMĐT",
      "OTHER": "Khác",
      "SEPAY": "SePay"
    },
    "lastReminderSentAt": "Đã nhắc gần nhất",
    "markPaid": "Đánh dấu đã thanh toán",
    "copyLink": "Chép link",
    "qrConsequence": "Phụ huynh chuyển đúng QR thì hoá đơn tự chuyển Đã thanh toán, bạn không phải làm gì thêm.",
    "qrDepositNote": "Hoá đơn có tiền cọc: gửi link để phụ huynh thanh toán phần còn lại."
  },
  "sendDialog": {
    "title": {
      "send": "Gửi hoá đơn cho khách",
      "reminder": "Gửi nhắc thanh toán"
    },
    "subtitle": {
      "send": "Chọn cách gửi hoá đơn cho khách.",
      "reminder": "Chọn cách nhắc khách thanh toán."
    },
    "drafting": "Đang soạn nội dung...",
    "draftFailed": "AI không soạn được, vui lòng nhập tay",
    "field": {
      "to": "Gửi tới",
      "subject": "Tiêu đề",
      "body": "Nội dung"
    },
    "cancel": "Huỷ",
    "close": "Đóng",
    "send": "Gửi",
    "sending": "Đang gửi...",
    "toast": {
      "sent": "Đã gửi hoá đơn",
      "reminded": "Đã gửi nhắc",
      "error": "Có lỗi, thử lại"
    },
    "tabs": {
      "manual": "Gửi tay",
      "auto": "Zalo tự động",
      "email": "Email",
      "emailDisabledHint": "Khách chưa có email, dùng tab Gửi tay để gửi qua Zalo hoặc mã QR."
    },
    "manual": {
      "messageLabel": "Nội dung tin nhắn",
      "copyMessage": "Sao chép nội dung",
      "messageCopied": "Đã sao chép nội dung",
      "messageCopyFailed": "Không sao chép được nội dung",
      "editTemplatePrefix": "Sửa mẫu tin nhắn trong",
      "editTemplateLinkLabel": "Tùy chọn"
    },
    "auto": {
      "comingSoon": "Sắp có mặt: gửi hóa đơn tự động qua Zalo ZNS."
    },
    "zalo": {
      "linkLabel": "Link công khai hoá đơn",
      "copy": "Sao chép",
      "copied": "Đã sao chép link",
      "copyFailed": "Không sao chép được link",
      "qrLabel": "Mã QR chuyển khoản",
      "paymentRef": "Nội dung chuyển khoản",
      "markSharedAction": "Đánh dấu đã gửi",
      "markedToast": "Đã đánh dấu đã gửi",
      "reminderHint": "Sao chép nội dung hoặc mã QR để nhắc khách.",
      "qrShare": "Chia sẻ",
      "qrCopy": "Sao chép ảnh",
      "qrCopied": "Đã chép ảnh",
      "qrDownload": "Tải về",
      "qrActionFailed": "Không lấy được ảnh QR, thử lại nhé",
      "nothingToCollect": "Hoá đơn này không còn khoản nào cần thu, không cần mã QR hay gửi qua Zalo."
    },
    "qrError": {
      "loading": "Đang tạo mã QR...",
      "bankNotLinked": "Chưa liên kết tài khoản ngân hàng.",
      "unsupportedBank": "Ngân hàng này chưa được hỗ trợ tạo mã VietQR.",
      "linkBank": "Liên kết ngân hàng",
      "retry": "Thử lại"
    }
  },
  "form": {
    "title": "Tạo hoá đơn",
    "titleExtra": "Tạo hoá đơn bán thêm",
    "titleEdit": "Sửa hoá đơn",
    "invoiceDetails": "Thông tin hoá đơn",
    "client": "Khách hàng *",
    "selectClient": "Chọn khách hàng",
    "clientSearchPlaceholder": "Tìm theo tên hoặc SĐT...",
    "clientEmpty": "Không tìm thấy khách hàng",
    "dueDate": "Hạn thanh toán *",
    "selectDate": "Chọn ngày",
    "lineItems": "Sản phẩm/dịch vụ",
    "addItem": "Thêm sản phẩm/dịch vụ",
    "description": "Mô tả",
    "descriptionPlaceholder": "Sách giáo trình, bộ dụng cụ học tập...",
    "qty": "SL",
    "negativeQtyHint": "Nhập số lượng âm để trừ vào hoá đơn, ví dụ tiền học đã thu ngoài hệ thống.",
    "unitPrice": "Đơn giá (VND)",
    "lineTotal": "Thành tiền",
    "additionalInfo": "Thông tin thêm",
    "notes": "Ghi chú / Điều khoản",
    "notesPlaceholder": "Cảm ơn quý khách...",
    "summary": "Tổng kết",
    "subtotal": "Tạm tính",
    "taxRate": "Thuế suất (%)",
    "taxAmount": "Tiền thuế",
    "total": "Tổng cộng",
    "cancel": "Huỷ",
    "submit": "Tạo hoá đơn",
    "submitting": "Đang tạo...",
    "submitEdit": "Lưu thay đổi",
    "savingEdit": "Đang lưu...",
    "selectClientAlert": "Vui lòng chọn khách hàng",
    "editLockedToast": "Chỉ sửa được hoá đơn nháp",
    "fromClosingBadge": "Từ chốt sổ",
    "fromClosingTooltip": "Hạng mục sinh từ chốt sổ nên không sửa/xoá được để không lệch đối soát. Chỉ thêm/sửa hạng mục phụ.",
    "negativeTotalError": "Tổng tiền đang âm do khoản trừ lớn hơn hoá đơn, giảm số lượng trừ hoặc thêm hạng mục để tổng tiền không âm.",
    "manualOnClosingHint": "Hạng mục thêm tay không được tính vào bù trừ tháng sau. Nếu số buổi sai vì xếp lịch sai, sửa lịch rồi xoá hoá đơn nháp này và chốt sổ lại; chỉ thêm tay những khoản ngoài học phí hoặc tiền đã thu ngoài."
  },
  "status": {
    "DRAFT": "Nháp",
    "SENT": "Đã gửi",
    "PENDING": "Chờ thanh toán",
    "PARTIAL": "Trả một phần",
    "PAID": "Đã thanh toán",
    "OVERDUE": "Quá hạn",
    "CANCELLED": "Đã huỷ"
  },
  "bulk": {
    "bar": {
      "summary": "Đã chọn {{count}} hoá đơn · Tổng {{total}}",
      "markPaid": "Đánh dấu đã thanh toán ({{eligible}}/{{count}})",
      "delete": "Xóa nháp ({{draft}}/{{count}})",
      "dueDate": "Sửa hạn thanh toán ({{draft}}/{{count}})",
      "clear": "Bỏ chọn",
      "selectAll": "Chọn tất cả",
      "ariaLabel": "Thao tác hàng loạt trên hoá đơn đã chọn"
    },
    "markPaidDialog": {
      "title": "Đánh dấu đã thanh toán",
      "description": "{{eligible}} hoá đơn sẽ được đánh dấu đã thanh toán.",
      "descriptionWithSkipped": "{{eligible}} hoá đơn sẽ được đánh dấu đã thanh toán, {{skipped}} hoá đơn sẽ được bỏ qua (đã thanh toán hoặc đã huỷ).",
      "source": "Nguồn thanh toán",
      "cancel": "Huỷ",
      "confirm": "Đánh dấu đã thanh toán",
      "confirming": "Đang xử lý..."
    },
    "deleteDialog": {
      "title": "Xoá hoá đơn nháp",
      "description": "{{eligible}} hoá đơn nháp sẽ bị xoá vĩnh viễn. Hành động này không thể hoàn tác.",
      "descriptionWithSkipped": "{{eligible}} hoá đơn nháp sẽ bị xoá vĩnh viễn, {{skipped}} hoá đơn không phải nháp sẽ được bỏ qua. Hành động này không thể hoàn tác.",
      "cancel": "Huỷ",
      "confirm": "Xoá {{eligible}} hoá đơn",
      "confirming": "Đang xoá..."
    },
    "dueDateDialog": {
      "title": "Sửa hạn thanh toán",
      "description": "{{eligible}} hoá đơn nháp sẽ được cập nhật hạn thanh toán.",
      "descriptionWithSkipped": "{{eligible}} hoá đơn nháp sẽ được cập nhật hạn thanh toán, {{skipped}} hoá đơn không phải nháp sẽ được bỏ qua.",
      "label": "Hạn thanh toán mới",
      "past": "Hạn thanh toán phải là hôm nay hoặc sau đó.",
      "cancel": "Huỷ",
      "confirm": "Cập nhật {{eligible}} hoá đơn",
      "confirming": "Đang cập nhật..."
    },
    "toast": {
      "markPaidSuccess": "Đã đánh dấu {{count}} hoá đơn đã thanh toán",
      "markPaidSuccessWithSkipped": "Đã đánh dấu {{count}} hoá đơn đã thanh toán ({{skipped}} hoá đơn bị bỏ qua)",
      "markPaidError": "Không đánh dấu được các hoá đơn đã chọn, thử lại",
      "deleteSuccess": "Đã xoá {{count}} hoá đơn nháp",
      "deleteSuccessWithSkipped": "Đã xoá {{count}} hoá đơn nháp ({{skipped}} hoá đơn bị bỏ qua)",
      "deleteError": "Không xoá được các hoá đơn đã chọn, thử lại",
      "dueDateSuccess": "Đã cập nhật hạn thanh toán cho {{count}} hoá đơn",
      "dueDateSuccessWithSkipped": "Đã cập nhật hạn thanh toán cho {{count}} hoá đơn ({{skipped}} hoá đơn bị bỏ qua)",
      "dueDateError": "Không cập nhật được hạn thanh toán, thử lại",
      "viewLog": "Xem trong nhật ký"
    }
  },
  "autoMatch": {
    "today": "Tự khớp chuyển khoản lúc {{time}} hôm nay",
    "on": "Tự khớp chuyển khoản lúc {{time}} {{date}}"
  },
  "reviewTargets": {
    "title": "Nhận xét tháng {{month}} · tháng vừa học xong"
  }
}
